import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchNeedTypesByCode(ctx, { codeId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`reservation/product-need-type/by-code/${codeId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchNeedType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`reservation/product-need-type/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateNeedType(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`reservation/product-need-type/${id}/update`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    toggleAvailable(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`reservation/product-need-type/${id}/toggle-available`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
